import { PropsWithChildren } from 'react';

import { useAuthentication } from '~/hooks/useAuthentication';

export const RequireAuthentication: React.FC<PropsWithChildren<object>> = ({ children }) => {
    const { isAuthenticated, isAuthLoading } = useAuthentication(false);

    if (!isAuthenticated || isAuthLoading) {
        return null;
    }

    return <>{children}</>;
};
